import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from "prop-types";

const PrivateRoute = ({ component: Component, ...rest }) => {

    const uclToken = localStorage.getItem('uclToken');
    return (
        <Route {...rest} render={props => {
            if (uclToken) { return <Component {...props} />; }
            return <Redirect to={{ pathname: '/login' }} />;
        }} />
    );
}

PrivateRoute.propTypes = {
    component: PropTypes.elementType
};

export default PrivateRoute;
